import { apiClient } from './apiClient'

export interface GenerateTokenDto {
  clientId: string
  clientSecret: string
}

export interface LoginDto {
  email: string
  password: string
}

export interface AccessTokenResponse {
  accessToken: string
}

export interface UserResponse { 
  id: string;
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  accountId: string;
  accountName: string;
  roles: any;
 }

export interface SwitcherAccount {
  id: string;
  name: string;
}

export interface SwitchAccountResponse {
  accessToken: string;
  actingAsAccountId: string;
  expiresIn: number;
  refreshToken: string;
}

 export interface ForgotPasswordDto {
  email: string
}

export interface ForgotPasswordResponse {
  message: string
}

export interface VerifyTokenDto {
  token: string
}

export interface VerifyTokenResponse {
  valid: boolean
  email: string
  expiresAt: string
}

export interface resetPasswordResponse {
  message: string
}

export const authService = {
  generateToken: (credentials: GenerateTokenDto): Promise<AccessTokenResponse> =>
    apiClient.post('/auth/generateToken', credentials).then(res => res.data),
  
  login: (credentials: LoginDto): Promise<AccessTokenResponse> =>
    apiClient.post('/auth/login', credentials).then(res => res.data),

  logout: (): Promise<void> =>
    apiClient.post('/auth/logout').then(res => res.data),

  getUser: (): Promise<UserResponse> =>
    apiClient.get('/users/me').then(res => res.data),

  forgotPasswordRequest: (credentials: ForgotPasswordDto): Promise<ForgotPasswordResponse> =>
    apiClient.post('/auth/password-reset/request', credentials).then(res => res.data),

  verifyToken: (token: string): Promise<VerifyTokenResponse> =>
    apiClient.post('/auth/password-reset/verify', { token }).then(res => res.data),

  resetPassword: (resetData: any): Promise<resetPasswordResponse> =>
    apiClient.post('/auth/password-reset/confirm', resetData).then(res => res.data),

  changePassword: (data: { id: string, newPassword: string }): Promise<resetPasswordResponse> =>
    apiClient.post(`/users/${data.id}/reset-password`, data).then(res => res.data),

  updateProfile: (data: { firstName: string; lastName: string; email: string }, id: string): Promise<UserResponse> =>
    apiClient.patch(`/users/${id}`, data).then(res => res.data),

  getUsers: (search?: string): Promise<UserResponse[]> =>
    apiClient.get('/users', { params: { search } }).then(res => res.data),

  createUser: (data: { firstName: string; lastName: string; email: string }): Promise<UserResponse> =>
    apiClient.post('/users', data).then(res => res.data),

  getClientCredentials: (userId: string): Promise<{clientId?: string, clientSecret?: string}> =>
    apiClient.get(`auth/record/${userId}`).then(res => res.data),

  getSwitcherAccounts: (): Promise<SwitcherAccount[]> =>
    apiClient.get('/accounts/switcher').then(res => res.data),

  switchAccount: (accountId: string): Promise<SwitchAccountResponse> =>
    apiClient.post('/auth/switch-account', { accountId }).then(res => res.data),

}